module.exports = __webpack_public_path__ + "img/magazine-cover-1.da33dc5f.jpg";